import apiClient from "../apiClient";

import type { UserInfo } from "#/entity";

export interface SignInReq {
	email: string;
	password: string;
}

export interface SignUpReq extends SignInReq {
	// email already included from SignInReq
}

export interface SignInRes {
	code: number;
	data: {
		user: {
			id: number;
			email: string;
			name: string;
			role: string;
			status: string;
			avatar: string | null;
			isNewUser: boolean;
			createdAt: string;
			updatedAt: string;
		};
		accessToken: string;
		refreshToken: string;
		expiresIn: string;
	};
	message: string;
	requestId: string;
	timestamp: number;
}

export enum UserApi {
	SignIn = "/auth/login",
	SignUp = "/auth/signup",
	Logout = "/auth/logout",
	Refresh = "/auth/refresh",
	User = "/user",
}

const signin = (data: SignInReq) => apiClient.post<SignInRes>({ url: UserApi.SignIn, data });
const signup = (data: SignUpReq) => apiClient.post<SignInRes>({ url: UserApi.SignUp, data });
const logout = () => apiClient.get({ url: UserApi.Logout });
const findById = (id: string) => apiClient.get<UserInfo[]>({ url: `${UserApi.User}/${id}` });

// 默认登录函数
const signinDefault = () =>
	signin({
		email: "admin@gpthumanizer.com",
		password: "admin123",
	});

export default {
	signin,
	signup,
	findById,
	logout,
	signinDefault,
};
